import { takeEvery, put, call, select } from 'redux-saga/effects'
import moment from 'moment'

import { FEED_RECENT, FEED_RECENT_LOAD_MORE, FEED_RECENT_SCROLL } from '../actionTypes'
import { feedRecent, feedRecentLoadMore, enableFeedRecentGetPending, enableFeedRecentLoadMorePending } from '../actions'
import {
  getFeedRecentPagination,
  getFeedPendingGetRecent,
  getFeedPendingGetRecentLoadMore,
  getFeedLoadedGetRecentLoadMore,
  getFeedFilterByRange,
  getLastItemInRecentList,
} from '../selectors'
import makeAPIRequest from 'store/entities/api/sagas'
import { showError } from 'store/entities/toastr/utils'
import { GET_FEED } from 'app/constants/api/feed'
import { FEED_RANGE } from 'app/constants/feed'

export default function* getRecentSaga() {
  yield* [
    takeEvery(FEED_RECENT.GET.REQUEST, handleGetRecentRequest),
    takeEvery(FEED_RECENT_LOAD_MORE.GET.REQUEST, handleLoadMoreRecentRequest),
    takeEvery(FEED_RECENT_SCROLL, handleFeedScroll),
  ]
}

export function* handleFeedScroll({ payload: { scrollTop, clientHeight, scrollHeight } }) {
  const loaded = yield select(getFeedLoadedGetRecentLoadMore)
  const range = yield select(getFeedFilterByRange)
  const lastItem = yield select(getLastItemInRecentList)
  const allowRequest = FEED_RANGE.all === range || moment(lastItem.get('timestamp')) > moment().day(-range)
  if (!loaded && scrollTop.recent + clientHeight >= scrollHeight && allowRequest) {
    yield put(feedRecentLoadMore.get.request())
  }
}

export function* handleLoadMoreRecentRequest() {
  try {
    const pending = yield select(getFeedPendingGetRecentLoadMore)
    if (!pending) {
      yield put(enableFeedRecentLoadMorePending)
      const data = yield makeGetRecentRequest(true)
      yield put(feedRecentLoadMore.get.success(data))
    }
  } catch (badResponse) {
    showError()
    yield put(feedRecentLoadMore.get.fail(badResponse))
  }
}

export function* makeGetRecentRequest(isNext = false) {
  const recentPagination = yield select(getFeedRecentPagination)
  const page = recentPagination.get('page') + isNext
  const limit = recentPagination.get('limit')
  const { data } = yield call(makeAPIRequest, `${GET_FEED}?page=${page}&limit=${limit}&sort=timestamp&desc=1`, {
    method: 'GET',
  })
  return data
}

export function* handleGetRecentRequest() {
  try {
    const pending = yield select(getFeedPendingGetRecent)
    if (!pending) {
      yield put(enableFeedRecentGetPending)
      const data = yield makeGetRecentRequest()
      yield put(feedRecent.get.success(data))
    }
  } catch (badResponse) {
    showError()
    yield put(feedRecent.get.fail(badResponse))
  }
}
